// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__36DZZ","calendarButtons":"ClockData_calendarButtons__enDAg"};